export default "__VITE_ASSET__BpqIwHgF__"